import React from 'react';
import { Link } from 'react-router';
import Logo3D from './Logo3D';
import AnimatedButton from './AnimatedButton';

const HeroSection = () => {
  return (
    <section style={{
      paddingTop: '100px'
    }}>
      {/* aling the container to center */}
      <div className='container hero-flex flex flex-col md:flex-row md:items-center md:justify-between gap-6 md:gap-12 lg:gap-16'>
        <div className='hero-left flex flex-col items-center text-center md:items-start md:text-left w-full md:w-1/2 lg:w-5/12'>
          <h1 className='text-2xl md:text-4xl font-bold mb-4 text-white'>
            Start Generating AI Images Instantly — No Setup Required
          </h1>
          <p className='text-base md:text-lg text-gray-200 mb-8'>
            Join 1,000+ developers who’ve generated over 10M images & videos via our API — all with a simple REST call and 99.99% uptime SLA.
          </p>
          <div className='hero-cta-buttons flex flex-col md:flex-row gap-4 w-full md:w-auto items-center justify-center mb-8'>
            <AnimatedButton to='https://account.fluxuro.ai'>
              Get Started
            </AnimatedButton>
            <Link
              to='/pricing'
              className='text-[#ff6a00] font-semibold underline hover:text-[#ff6a00] transition-all duration-150'
            >
              View API Pricing →
            </Link>
          </div>
          <div className='hero-stats-row'>
            <div className='stat-group'>
              <span className='stat-label'>10M+ </span>
              <span className='stat-desc'>Image Generations via API</span>
            </div>
            <div className='stat-group'>
              <span className='stat-label'>1,000+ </span>
              <span className='stat-desc'>Developers Using Uro API</span>
            </div>
          </div>
        </div>
        <div className='flex justify-center md:justify-end mt-6 md:mt-0'>
          <Logo3D />
        </div>
      </div>
    </section>
  );
};

export default HeroSection;